import PropTypes from 'prop-types';

import IconButton from '@mui/material/IconButton';

import { varHover } from 'src/components/animate';
import Iconify from "src/components/iconify/index";

// ----------------------------------------------------------------------

export default function CompanyLinkButton({ sx }) {
  return (
    <IconButton
      className="company-link-button"
      component="a"
      href={import.meta.env.VITE_COMPANY_LINK}
      whileTap="tap"
      whileHover="hover"
      variants={varHover(1.05)}
      aria-label="settings"
      sx={{
        width: 40,
        height: 40,
        ...sx,
      }}
    >
      <Iconify icon="solar:buildings-bold-duotone" width={24} />
    </IconButton>
  );
}

CompanyLinkButton.propTypes = {
  sx: PropTypes.object,
};
